import {FAILURE, PENDING, SUCCESS} from '../../constants'
import {useReducer} from 'react'

const ActionTypes = {FAILURE, PENDING, SUCCESS}

const InitialState = {
  data: [],
  field_type: null,
  field_id: null,
  error: null,
  isLoading: false,
}

const Reducer = (state = InitialState, action) => {
  switch (action.type) {
    case PENDING:
      return {
        ...state,
        isLoading: true,
        error: null,
      }
    case SUCCESS:
      return {
        ...state,
        isLoading: false,
        error: null,
        field_type: action.payload.field_type,
        field_id: action.payload.field_id,
        data: action.payload.values || [],
      }
    case FAILURE:
      return {
        ...state,
        error: action.payload,
        isLoading: false,
      }
    default:
      return state
  }
}

const useGetGroupFilterValuesReducer = (state = InitialState) => {
  return useReducer(Reducer, state)
}

export default useGetGroupFilterValuesReducer

export {ActionTypes, InitialState, Reducer}
